module.exports = __webpack_public_path__ + "img/SpectroPicPostcard.2ec54849.png";